import '../../../scss/feature.scss';
import '../../../scss/critical.scss';

import Vue from 'vue';
import router from "../../qaamgo/modules/sat/components/result_v2/router"
import 'blueimp-file-upload';
import {getPiniaInstance} from "../../lib-sat/store/page-store";
import { PiniaVuePlugin } from 'pinia';
import TransFilter from '../../qaamgo/modules/sat/components/mixins/TransFilter.vue'
import ResultV2 from "../../qaamgo/modules/sat/components/result_v2/ResultV2.vue";


const $ = require('jquery');
global.$ = global.jQuery = $;

import(
    /* webpackMode: "eager" */
    '../qg-main'
    ).then(function () {

    import(
        /* webpackMode: "lazy-once" */
        `../translations/sat/${sat.locale}.js`
        ).then(function () {

    const pinia = getPiniaInstance();

    Vue.mixin(TransFilter);
    Vue.filter('truncate', (value, length, clamp) => {
        if (value.length <= length) {
            return value;
        } else {
            return value.slice(0, length) + clamp;
        }
    });

    let resultv2 = new Vue({
        el: '#ResultV2',
        name: 'ResultV2',
        components: { ResultV2 },
        pinia,
        router,
        render(h) {
            return h(ResultV2);
        },
    });
    });

});
